import { IAttributeField } from 'interfaces/documentation/document-attribute-field';
import type { FormRule } from 'antd';
import type { NamePath } from 'antd/es/form/interface';

/**
 * GERE6-473 — o template `identity` usa um campo de número só para RG e CIN,
 * com um `max` só. Esse `max` foi pensado para o RG e é editado por tenant
 * (no IBMEC Solcorp é 10), mas na CIN o número é o CPF, com 11 dígitos — e
 * 14 com a máscara. Com CIN o limite do template não vale: o atlas valida o
 * CPF e devolve 422 se não for válido.
 *
 * O nome do campo é rótulo e chave ao mesmo tempo, igual ao atlas
 * (`Documents::IdentityFields`).
 */
export const IDENTITY_DOCUMENT_TYPE_FIELD = 'Tipo de documento';
const IDENTITY_NUMBER_FIELD = 'Número do documento';
const CIN = 'CIN';

export const maxLengthRule = (
  field: Pick<IAttributeField, 'name' | 'max'>,
  documentTypeName: NamePath
): FormRule | undefined => {
  const { max } = field;

  if (!max) {
    return undefined;
  }

  const message = `Máximo ${max} caracteres`;

  if (field.name !== IDENTITY_NUMBER_FIELD) {
    return { max, message };
  }

  return ({ getFieldValue }) => ({
    max: getFieldValue(documentTypeName) === CIN ? undefined : max,
    message
  });
};

/** Só o número depende do tipo; os outros campos não precisam revalidar. */
export const maxLengthDependencies = (
  field: Pick<IAttributeField, 'name'>,
  documentTypeName: NamePath
): NamePath[] | undefined =>
  field.name === IDENTITY_NUMBER_FIELD ? [documentTypeName] : undefined;
